var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useCallback, useEffect, useMemo } from 'react';
import { Button, Modal, Tooltip, message } from 'antd';
import UserSelection, { SelectorMode, } from '../UserSelection/index';
import { InputPlacement } from './types';
import InputArea from './InputArea';
import InputAreaContext from './context';
import classNames from 'classnames';
import { debounce } from 'lodash';
import closeIcon from '../images/Close.png';
import pc_butten_help_kjia from '../images/pc_butten_help_kjia.png';
var Footer = function (_a) {
    var onOk = _a.onOk, onCancel = _a.onCancel, loading = _a.loading, notLoad = _a.notLoad, disabled = _a.disabled, footerExtra = _a.footerExtra, despInputValue = _a.despInputValue, extraInputValue = _a.extraInputValue, leaveWordInputValue = _a.leaveWordInputValue, strangerLeaveWordInputValue = _a.strangerLeaveWordInputValue, onInputDespChange = _a.onInputDespChange, onInputExtraChange = _a.onInputExtraChange, onInputLeaveWordChange = _a.onInputLeaveWordChange, onInputStrangerLeaveWordChange = _a.onInputStrangerLeaveWordChange, cancelText = _a.cancelText, okText = _a.okText;
    var inputPlacement = React.useContext(InputAreaContext).inputPlacement;
    return (React.createElement("div", null,
        inputPlacement && inputPlacement !== InputPlacement.bodyRightBottom && (React.createElement(InputArea, { onInputStrangerLeaveWordChange: onInputStrangerLeaveWordChange, onInputLeaveWordChange: onInputLeaveWordChange, onInputDespChange: onInputDespChange, onInputExtraChange: onInputExtraChange, despInputValue: despInputValue, extraInputValue: extraInputValue, leaveWordInputValue: leaveWordInputValue, strangerLeaveWordInputValue: strangerLeaveWordInputValue })),
        React.createElement("div", { className: "focus-user-selection-footer-extra" },
            React.createElement("div", { className: "focus-user-selection-footer-extra" }, footerExtra),
            React.createElement("div", { className: "focus-user-selection-footer-btn" },
                React.createElement(Button, { onClick: onCancel }, cancelText || '取消'),
                React.createElement(Button, { disabled: disabled, type: "primary", onClick: onOk, loading: notLoad ? false : loading }, okText || '确定')))));
};
export default function UserSelectionModal(_a) {
    var _this = this;
    var options = _a.options, visible = _a.visible, defaultUserAvatar = _a.defaultUserAvatar, onClose = _a.onClose, onOk = _a.onOk, t = _a.t, onCancel = _a.onCancel, rest = __rest(_a, ["options", "visible", "defaultUserAvatar", "onClose", "onOk", "t", "onCancel"]);
    var _b = options.title, title = _b === void 0 ? t('userSelection.title') : _b, mode = options.mode, cid = options.cid, extraInput = options.extraInput, despInput = options.despInput, leaveWordInput = options.leaveWordInput, strangerLeaveWordInput = options.strangerLeaveWordInput, validate = options.validate, notLoad = options.notLoad, inputPlacement = options.inputPlacement, inputWrapClass = options.inputWrapClass, modalWrapClass = options.modalWrapClass, rightExtra = options.rightExtra, dataListFilter = options.dataListFilter, footerExtra = options.footerExtra, modalOptions = options.modalOptions, smallModal = options.smallModal, defaultLimitOpt = options.defaultLimitOpt;
    var _c = React.useState(mode || SelectorMode.user), newMode = _c[0], setNewMode = _c[1];
    var _d = React.useState((extraInput === null || extraInput === void 0 ? void 0 : extraInput.defaultValue) || ''), extraInputValue = _d[0], setExtraInputValue = _d[1];
    var _e = React.useState(''), despInputValue = _e[0], setDespInputValue = _e[1];
    var _f = React.useState(''), leaveWordInputValue = _f[0], setLeaveWordInputValue = _f[1];
    var _g = React.useState((strangerLeaveWordInput === null || strangerLeaveWordInput === void 0 ? void 0 : strangerLeaveWordInput.placeholder) || ''), strangerLeaveWordInputValue = _g[0], setStrangerLeaveWordInputValue = _g[1];
    var _h = React.useState(defaultLimitOpt || null), selectedLimit = _h[0], setSelectedLimit = _h[1];
    var _j = React.useState([]), result = _j[0], setResult = _j[1];
    var _k = React.useState([]), strangerResult = _k[0], setStrangerResult = _k[1];
    var _l = React.useState([]), strangerList = _l[0], setStrangerList = _l[1];
    var _m = React.useState(false), loading = _m[0], setLoading = _m[1];
    var Ref = React.useRef(false);
    var bodyHeight = useMemo(function () {
        if (inputPlacement !== InputPlacement.bodyRightBottom &&
            (extraInput || despInput || leaveWordInput || strangerLeaveWordInput)) {
            return 'calc(85vh - 215px)';
        }
        else {
            return 'calc(85vh - 130px)';
        }
    }, [extraInput, despInput, leaveWordInput, inputPlacement, strangerLeaveWordInput]);
    var bodyWidth = useMemo(function () {
        if (document.body.offsetWidth > 750) {
            return 800;
        }
        return 620;
    }, []);
    useEffect(function () {
        if (visible) {
            Ref.current = visible;
        }
    }, [visible]);
    var footerUserNode = (React.createElement(Footer, { disabled: result.length <= 0 && newMode !== SelectorMode.group, loading: loading, notLoad: notLoad, extraInputValue: extraInputValue, despInputValue: despInputValue, leaveWordInputValue: leaveWordInputValue, strangerLeaveWordInputValue: strangerLeaveWordInputValue, onInputExtraChange: function (val) {
            setExtraInputValue(val);
        }, onInputDespChange: function (val) {
            setDespInputValue(val);
        }, onInputLeaveWordChange: function (val) {
            setLeaveWordInputValue(val);
        }, onInputStrangerLeaveWordChange: function (val) {
            setStrangerLeaveWordInputValue(val);
        }, t: t, result: result, footerExtra: footerExtra, onOk: debounce(function () { return __awaiter(_this, void 0, void 0, function () {
            var rst, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        rst = {
                            cid: cid,
                            data: {
                                strangerResult: strangerList,
                                result: result.map(function (item) {
                                    var _a;
                                    if (rightExtra && rightExtra.key && !item[rightExtra.key]) {
                                        return __assign(__assign({}, item), (_a = {}, _a[rightExtra.key] = rightExtra.defaultValue, _a));
                                    }
                                    if (item.isWorkLine) {
                                        return __assign(__assign({}, item), { deptName: item.name, deptId: item.deptId || item.nodeId, isNode: true });
                                    }
                                    return item;
                                }),
                                extraString: extraInputValue,
                                despInputValue: despInputValue,
                                leaveWordInputValue: leaveWordInputValue,
                                strangerLeaveWordInputValue: strangerLeaveWordInputValue,
                                selectedLimit: selectedLimit,
                            },
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 5, , 6]);
                        setLoading(true);
                        if (!validate) return [3 /*break*/, 3];
                        return [4 /*yield*/, validate(rst)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [4 /*yield*/, onOk(rst)];
                    case 4:
                        _a.sent();
                        setLoading(false);
                        return [3 /*break*/, 6];
                    case 5:
                        error_1 = _a.sent();
                        console.error(error_1);
                        setLoading(false);
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        }); }, 500), onCancel: function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!onCancel) return [3 /*break*/, 2];
                        return [4 /*yield*/, onCancel(onClose())];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        onClose();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        }); } }));
    var TooltipTitle = useCallback(function () {
        return (React.createElement("div", { className: "Tooltip-title" }, "\u975E\u8054\u7CFB\u4EBA\u662F\u60A8\u5728\u201C\u901A\u8BAF\u5F55\u201D\u4E2D\u770B\u4E0D\u5230\u7684\u7528\u6237\u3002 \u201C\u9009\u62E9\u975E\u8054\u7CFB\u4EBA\u201D\u53EF\u4EE5\u5411\u201C\u975E\u8054\u7CFB\u4EBA\u201D\u53D1\u8D77\u5165\u7EC4\u7533\u8BF7 \uFF0C\u5BF9\u65B9\u901A\u8FC7\u540E\u65B9\u53EF\u8FDB\u5165\u7FA4\u7EC4\uFF0C\u4E0D\u4F1A\u4EA7\u751F\u5176\u4F59\u64CD\u4F5C\u3002"));
    }, []);
    var footerStrangerNode = useMemo(function () {
        return (React.createElement(Footer, { loading: false, notLoad: false, t: t, result: result, footerExtra: footerExtra, onOk: debounce(function () {
                if (strangerResult.length && !strangerLeaveWordInputValue) {
                    message.error('内容不能为空');
                    return;
                }
                setNewMode(SelectorMode.user);
                setStrangerList(strangerResult);
            }, 500), onCancel: function () {
                setNewMode(SelectorMode.user);
                setStrangerResult(strangerList);
                setStrangerList(strangerList);
            } }));
    }, [strangerResult, t, result, footerExtra, strangerLeaveWordInputValue, strangerList]);
    var footerNode = React.useMemo(function () {
        switch (newMode) {
            case SelectorMode.stranger:
                return footerStrangerNode;
            default:
                return footerUserNode;
        }
    }, [footerStrangerNode, footerUserNode, newMode]);
    return (React.createElement(InputAreaContext.Provider, { value: {
            despInput: despInput,
            extraInput: extraInput,
            leaveWordInput: leaveWordInput,
            strangerLeaveWordInput: strangerLeaveWordInput,
            inputPlacement: inputPlacement,
            overlayClassName: inputWrapClass,
            newMode: newMode,
            setNewMode: setNewMode,
            strangerResult: strangerResult,
            setStrangerResult: setStrangerResult,
        } },
        React.createElement(Modal, __assign({ visible: visible, title: newMode === SelectorMode.stranger ? (React.createElement("span", null,
                "\u9080\u8BF7\u975E\u8054\u7CFB\u4EBA",
                React.createElement(Tooltip, { placement: "top", title: TooltipTitle },
                    React.createElement("img", { src: pc_butten_help_kjia, alt: "", style: {
                            marginLeft: '6px',
                            fontSize: '12px',
                            width: 12,
                            verticalAlign: 'initial',
                        } })))) : (title), closeIcon: React.createElement("img", { src: closeIcon, alt: "", style: { width: 16 } }), closable: newMode !== SelectorMode.stranger, destroyOnClose: true, centered: true, footer: footerNode, wrapClassName: classNames('modalUserSelection', modalWrapClass), onCancel: onClose, style: {
                height: '85vh',
            }, width: bodyWidth, bodyStyle: {
                padding: 0,
                height: bodyHeight,
            } }, modalOptions),
            React.createElement(UserSelection, __assign({}, options, rest, { selectedLimit: selectedLimit, setSelectedLimit: setSelectedLimit, extraInputValue: extraInputValue, despInputValue: despInputValue, leaveWordInputValue: leaveWordInputValue, strangerLeaveWordInputValue: strangerLeaveWordInputValue, onInputExtraChange: function (val) {
                    setExtraInputValue(val);
                }, onInputDespChange: function (val) {
                    setDespInputValue(val);
                }, onInputLeaveWordChange: function (val) {
                    setLeaveWordInputValue(val);
                }, onInputStrangerLeaveWordChange: function (val) {
                    setStrangerLeaveWordInputValue(val);
                }, bodyHeight: bodyHeight, defaultUserAvatar: defaultUserAvatar, onResultChange: function (data) {
                    setResult(data);
                }, t: t })))));
}
//# sourceMappingURL=index.js.map